import React, { ReactNode } from 'react'
import { Modal } from 'react-bootstrap';

type Props = {
  showModal: any;
  hideModal: any;
  size?: "sm" | "lg" | "xl" | undefined;
  dialogClassName?: string;
  children: ReactNode;
}

const ModalComponent = ({children, size, showModal, dialogClassName, hideModal}: Props) => {
  return (
    <Modal scrollable centered size={size} show={showModal} dialogClassName={dialogClassName} onHide={hideModal}>
      <Modal.Body className='p-0 rounded-5'>
        {children}
      </Modal.Body>
    </Modal>
  )
}

export default ModalComponent;